import { AvatarGroup } from "@mui/material";
import { Idea } from "../../../w2d2d-api-client";
import AvatarWidget from "../users/AvatarWidget";

interface ParticipationViewProps {
    readonly idea: Idea | null
}

export default function ParticipationView({ idea }: ParticipationViewProps) {

    if (!idea) {
        return null
    }

    // Merge accepted and interested users, removing duplicates
    const participants = Array.from(new Set([
        ...(idea.accepted || []),
        ...(idea.interested || [])
    ]))

    if (participants.length === 0) {
        return null
    }

    return (
        <AvatarGroup max={5}>
            {participants.map((userId) => (
                <AvatarWidget key={userId} id={userId} size={32} />
            ))}
        </AvatarGroup>
    )
}
